<template>
  <el-menu-item class="policy-menu-item" index="newPolicy" route="policy">
    <el-tooltip effect="dark" content="You have to accept new policy" placement="bottom">
      <el-button type="danger">New Policy</el-button>
    </el-tooltip>
  </el-menu-item>
</template>

<script>
  export default {
    name: 'HeaderMenuPolicy',
  };
</script>



// WEBPACK FOOTER //
// src/components/HeaderMenuPolicy.vue